import React from "react";
import {
  MetaDataWrapper,
  TitleStyled,
  ChannelImageWrapper,
  ImageStyled,
  TagsWrapper,
  DescriptionWrapper,
  TimeWrapper,
  BackIconWrapper,
  TimeStatusWrapper,
  StatusWrapper,
  BackIcon,
  BackText,
  Tags
} from "./styles/Styled";
import { Image } from "../../../services/visualLibraryService";
import { calculateDurationForSlots, getStatusTagText, getTagsList } from "../../../utils/epgUtil";
import { Icon } from "../../../services/visualLibraryService";
import { directions, i18n } from "../../../services/i18nService";

export function getTagsListComponent(tagsList) {
  return tagsList && tagsList.length > 0 && tagsList.map(tag => <Tags key={tag}>{tag.toUpperCase()}</Tags>);
}

class VideoMetaData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onClickBackButton = this.onClickBackButton.bind(this);
    this.ref = React.createRef();
    this.borderToggle = false;
  }

  onClickBackButton() {
    this.props.onBack();
  }

  render() {
    const { videoData, currentView, isFocusOnEPG } = this.props;
    let { title, description, tsEnd, tsStart, channelImage, status, genres, parentalControl, channelType } =
      videoData || {};
    const tagsList = getTagsList(genres, parentalControl);

    return (
      videoData && (
        <MetaDataWrapper>
          <BackIconWrapper>
            <BackIcon
              className={i18n.getDirection() === directions.RIGHT_TO_LEFT ? "arabic " : ""}
              onClick={this.onClickBackButton}
            >
              <Icon name={"popup_back"} viewBoxValue="0 0 40 40" height="2.5rem" fill="#ffffff" />
            </BackIcon>
            {isFocusOnEPG && (
              <>
                <BackText direction={i18n.getDirection()}>
                  {currentView === 0
                    ? i18n.get("pages.livePage.videoMetaData.backToCategories")
                    : i18n.get("pages.livePage.videoMetaData.backToLive")}
                </BackText>
              </>
            )}
          </BackIconWrapper>
          <ChannelImageWrapper>
            <ImageStyled>
              <Image url={channelImage} alt={channelImage} />
            </ImageStyled>
          </ChannelImageWrapper>
          <TitleStyled>{title}</TitleStyled>
          <TimeStatusWrapper>
            <StatusWrapper status={getStatusTagText(status, channelType)} direction={i18n.getDirection()}>
              {i18n.get(`pages.livePage.tags.${getStatusTagText(status, channelType)}`)}
            </StatusWrapper>
            <TimeWrapper direction={i18n.getDirection()}>{calculateDurationForSlots(tsStart, tsEnd)}</TimeWrapper>
          </TimeStatusWrapper>
          <TagsWrapper>{getTagsListComponent(tagsList)}</TagsWrapper>
          <DescriptionWrapper>{description}</DescriptionWrapper>
        </MetaDataWrapper>
      )
    );
  }
}

export default VideoMetaData;
